import React from "react";
import * as Icons from "lucide-react";

export function LucideIcon({
     name,
     size = 24,
     strokeWidth = 2,
     color = "currentColor",
     className = ""
}) {
    const IconComponent = Icons[name];

    if (!IconComponent) {
        return (
            <span style={{ color: "red", fontSize: "12px" }}>
                ⚠ Icon "{name}" not found
            </span>
        );
    }

    return (
        <IconComponent
            size={size}
            strokeWidth={strokeWidth}
            color={color}
            className={className}
        />
    );
}
